import { SxStyleProp } from 'theme-ui';

export const AwardsListContainer: SxStyleProp = {
  padding: '100px 20px',
  flexDirection: 'column',
  alignItems: 'center',
};

export const AwardsText: SxStyleProp = {
  marginTop: '18px',
  marginBottom: '43px',
  maxWidth: '968px',
  textAlign: 'center',
  width: '100%',

  a: {
    color: 'lavender.100',
    textDecoration: 'none',
  },
};

export const AwardImage: SxStyleProp = {
  maxWidth: ['200px !important', '257px !important'],
  maxHeight: ['200px !important', '257px !important'],
  img: {
    objectFit: 'contain !important',
  },
  margin: 'auto',
};

export const AwardBox: SxStyleProp = {
  width: ['33%', '20%'],
  flexBasis: ['33%', '20%'],
  paddingX: ['20px'],
  marginBottom: ['20px', 'revert'],
};

export const AwardImagesContainer: SxStyleProp = {
  alignItems: 'center',
  flexWrap: 'wrap',
  // gap: '50px',
  justifyContent: 'space-around',
  margin: '44px auto 0 auto',
  width: '100%',
};

export const CtaButton: SxStyleProp = {
  marginTop: '50px',
};
